
import React, { Fragment } from 'react'
import { Col } from 'react-bootstrap'
import { Can } from '@casl/react';

import { useAuth } from '@/Hooks/UseAuth';

import ButtonAddTeam from '../ButtonAddTeam/ButtonAddTeam';
import LeftTeamSelector from './LeftTeamSelector'

const LeftTeamSide = () => {

  const { ability } = useAuth()

  return (
    <Col lg={4} xl={3} className="teams-left-side">
      <Fragment>
        <div className='team-selector-container'>
          <LeftTeamSelector />
          <div className="d-inline-block d-lg-none">
            <Can I="create" a="Team" ability={ability}>
              <ButtonAddTeam className='ml-1' />
            </Can>
          </div>
        </div>
      </Fragment>
    </Col>
  )
}

export default LeftTeamSide
